import { useSelector } from "react-redux";

const useVersionOne = () => {
  const { excelFormData, itemID, certificateNumber } = useSelector(
    (state) => state.cvd
  );
  const isFlatGradedData =
    excelFormData?.graded_values &&
    Object.values(excelFormData.graded_values).every(
      (value) => typeof value !== "object" || value === null
    );
  return {
    itemID,
    excelFormData,
    certificateNumber,
    isFlatGradedData,
  };
};

export default useVersionOne;
